module.exports = __webpack_public_path__ + "img/1_035.aa6ba032.jpg";